
import { ItemBoxDataType } from '@/views/Home.vue';

import { defineComponent, PropType } from 'vue';
import SvgIcon from '@/components/Icons/SvgIcon.vue';
import { FILESERVICE } from '@/config/defaultSetting';
import { useUserStore } from '@/store/modules/user';

export default defineComponent({
  name: 'SystemIntroductBox',
  components: {
    SvgIcon,
  },
  props: {
    itemBoxData: {
      type: Object as PropType<ItemBoxDataType>,
      default: () => {
        return {};
      },
    },
    currentIndex: {
      type: Number,
      default: 0,
    },
  },
  setup() {
    const userStore = useUserStore();

    function goSystemByhref(itemBoxData: ItemBoxDataType) {
      if (
        itemBoxData.onClickHandle &&
        hasApplicationPermission(itemBoxData.applicationCode)
      ) {
        itemBoxData.onClickHandle();
      }
    }

    function hasApplicationPermission(applicationCode: string | undefined) {
      if (!applicationCode) {
        return true;
      } else {
        const index =
          userStore.getApplicationPermission.indexOf(applicationCode);
        return index !== -1;
      }
    }
    return {
      FILESERVICE,
      goSystemByhref,
      hasApplicationPermission,
    };
  },
});
